var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function nl2br() {
  var str = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var isXHTML = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  if (!str) {
    return null;
  }
  return str.replace(new RegExp("\r?\n", "g"), isXHTML ? "<br />" : "<br>");
}
__name(nl2br, "nl2br");
export {
  nl2br
};
